export function Loader(){

    return (
        <h1>Loading...</h1>
    )
}